type TrackKind = 'audio' | 'subtitle';

export function selectHlsTrack(hls: any, kind: TrackKind, trackId: number): Promise<void> {
  if (!hls) return Promise.reject(new Error('HLS player unavailable'));
  const Hls = (window as any).Hls;
  const eventName = kind === 'audio' ? Hls?.Events?.AUDIO_TRACK_SWITCHED : Hls?.Events?.SUBTITLE_TRACK_SWITCH;
  const property = kind === 'audio' ? 'audioTrack' : 'subtitleTrack';
  const previousId = Number(hls[property]);
  if (previousId === trackId) return Promise.resolve();

  return new Promise((resolve, reject) => {
    let settled = false;
    const cleanup = () => {
      window.clearTimeout(timeout);
      if (eventName && typeof hls.off === 'function') hls.off(eventName, onSwitched);
    };
    const succeed = () => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve();
    };
    const fail = () => {
      if (settled) return;
      settled = true;
      cleanup();
      try { hls[property] = previousId; } catch { /* keep playback alive */ }
      reject(new Error('Track switch timed out'));
    };
    const onSwitched = (_event: unknown, data: any) => {
      const selectedId = typeof data?.id === 'number' ? data.id : Number(hls[property]);
      if (selectedId === trackId) succeed();
    };
    const timeout = window.setTimeout(fail, 8000);
    if (eventName && typeof hls.on === 'function') hls.on(eventName, onSwitched);
    try {
      hls[property] = trackId;
      if (!eventName) succeed();
    } catch {
      fail();
    }
  });
}
